import { IPageResultDto, IResponseBaseDto, IResponseBaseTDto, ISearchBaseDto } from "@sprytki-frontend-apps/common";
import { LockerOutOfUsePayload, PadLockPayload } from "api/interfaces/locker";
import { ILockerEventDto } from "api/interfaces/events";
import { apiClient } from "./apiClient";

const LOCKERS = 'lockers';

export const LockerServiceAPI = {
	open: async (id: string): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.post(`${LOCKERS}/${id}/open`);
		return response.data;
	},
	arm: async (id: string): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.post(`${LOCKERS}/${id}/alarm/arm`);
		return response.data;
	},
	disarm: async (id: string): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.post(`${LOCKERS}/${id}/alarm/disarm`);
		return response.data;
	},
	setOutOfUse: async (
		id: string,
		payload: LockerOutOfUsePayload
	): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.put(`${LOCKERS}/${id}/setOutOfUse`, payload);
		return response.data;
	},
	insertPadLock: async (id: string, payload?: PadLockPayload): Promise<IResponseBaseDto> => {
		const response = await apiClient.post(`${LOCKERS}/${id}/padLock`, payload);
		return response.data;
	},
	removePadLock: async (id: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.delete(`${LOCKERS}/${id}/padLock`);
		return response.data;
	},
	setAccessCode: async (id: string, code: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.put(`${LOCKERS}/${id}/code`, { code });
		return response.data;
	},
	setEmergencyCode: async (id: string, emergencyAccessCode: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.put(`${LOCKERS}/${id}/emergencyCode`, { emergencyAccessCode });
		return response.data;
	},
	getEvents: async (
		id: string,
		search: ISearchBaseDto
	): Promise<IResponseBaseTDto<IPageResultDto<ILockerEventDto>>> => {
		const response = await apiClient.post(`${LOCKERS}/${id}/events`, search);
		return response.data;
	}
};
